<template>
  <div class="combat-stat">
    <div class="img-container float-left">
      <img src="/static/images/icons/combat.png" loading="lazy" sizes="100%, 100%" width="auto" height="100%">
    </div>
    <div class="level-container float-left">
      <span class="ml-3">{{combat_level}}</span>
    </div>
  </div>
</template>

<script>
  import PlayerStat from "../PlayerStat";

  export default {
    name: "Combat",
    components: {PlayerStat},
    props: {
      stats: {
        type: Object,
        default() {
          return null
        }
      }
    },
    computed: {
      combat_level: function () {
        if (this.stats == null) {
          return 0;
        }

        if (this.stats.hasOwnProperty("combat_level"))
          return this.stats.combat_level; //Monsters only

        console.log(this.stats);
        const base = (this.stats.hitpoints.level + this.stats.defence.level + (this.stats.prayer.level / 2)) * 0.25;
        const melee = (this.stats.attack.level + this.stats.strength.level) * 0.325;
        const range = (Math.floor(this.stats.ranged.level / 2) + this.stats.ranged.level) * 0.325;
        const magic = (Math.floor(this.stats.magic.level / 2) + this.stats.magic.level) * 0.325;
        if (melee > (range | magic))
          return Math.floor(base + melee);

        if (range > magic)
          return Math.floor(base + range);


        return Math.floor(base + magic);
      }
    }
  }
</script>

<style scoped>
  .combat-stat {
    font-size: 1.8rem;
    line-height: 1.8rem;
    font-family: 'RuneScape UF', sans-serif;
    color: white;
  }

  img {
    /*transform: scale(1.2);*/
    height: 100%;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/stats/Combat.vue